// extracted by mini-css-extract-plugin
module.exports = {"provision":"artifactory_provision__VVa8y","tools":"artifactory_tools__p5JI2","supply_chain":"artifactory_supply_chain__FmCSZ","integration":"artifactory_integration__fbJcA"};